import FormGroup from '../../../components/ReusableComponents/ManageHotel/FormGroup/index'
import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import styles from './CheckinCheckout.module.scss'

const CheckinCheckout = ({
  formData: { checkInTime, checkOutTime, numberOfRooms },
  setFormData
}) => (
  <FormGroup title="Hotel details (optional)" done={checkInTime && checkOutTime}>
    <div className={styles.container}>
      <TextInput
        label="Check in time"
        className={styles.input}
        name="checkInTime"
        value={checkInTime}
        onChange={e =>
          setFormData({
            checkIn: e.target.value + ':00',
            checkInTime: e.target.value
          })
        }
        type="time"
      />
      <TextInput
        label="Check out time"
        className={styles.input}
        name="checkOutTime"
        value={checkOutTime}
        onChange={e =>
          setFormData({
            checkOut: e.target.value + ':00',
            checkOutTime: e.target.value
          })
        }
        type="time"
      />
      <TextInput
        type="number"
        label="Number of rooms"
        className={styles.input}
        name="numberOfRooms"
        value={numberOfRooms}
        onChange={e => setFormData({ numberOfRooms: Number(e.target.value) })}
      />
    </div>
  </FormGroup>
)

export default CheckinCheckout
